import React from 'react';
import AsyncPartnerLinkBuilder from './async';
import SingleColumnLayout from '../../../components/layout/SingleColumnLayout';
import {Trans} from 'react-i18next';

const parent = {
  title: <Trans i18nKey="p.p.partner.title">Online Service Partner</Trans>,
  path: '/partner',
};
export default [
  <SingleColumnLayout
    exact
    key="partner-link-builder"
    path="/partner/link-builder"
    component={AsyncPartnerLinkBuilder}
    title={<Trans i18nKey="p.p.linkbuilder.title">Link Builder</Trans>}
    parents={[parent]}
  />,
];
